module.exports = __webpack_public_path__ + "static/media/OppCal.e095412b.PNG";